"use strict";

var _classCallCheck = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureServicesManager = void 0;

var BackgroundJobService_1 = require("../services/BackgroundJobService");

var QueueService_1 = require("../services/QueueService");

var StubErrorService_1 = require("../services/stub/StubErrorService");
/** {@inheritDoc IFeatureServicesManager} */


var FeatureServicesManager = /*#__PURE__*/function () {
  function FeatureServicesManager(opts) {
    _classCallCheck(this, FeatureServicesManager);

    this.stubErrorService = new StubErrorService_1.StubErrorService();
    this.storageServices = {};
    this.cacheServices = {};
    this.queueServices = {};
    this.backgroundJobs = new BackgroundJobService_1.BackgroundJobService(opts.root);
    this.options = opts;
  }
  /** {@inheritDoc IFeatureServicesManager.setEmailService} */


  _createClass(FeatureServicesManager, [{
    key: "setEmailService",
    value: function setEmailService(service) {
      this.emailService = service;
    }
    /** {@inheritDoc IFeatureServicesManager.email} */

  }, {
    key: "addStorageService",

    /** {@inheritDoc IFeatureServicesManager.addStorageService} */
    value: function addStorageService(service) {
      this.storageServices[service.getScheme()] = service;
    }
    /** {@inheritDoc IFeatureServicesManager.storage} */

  }, {
    key: "storage",
    value: function storage(scheme) {
      var _a;

      if (scheme) {
        if (!this.storageServices[scheme]) {
          throw new Error("Storage scheme '".concat(scheme, "' required, but not defined."));
        } else {
          return this.storageServices[scheme];
        }
      } else if ((_a = this.options.defaults) === null || _a === void 0 ? void 0 : _a.storage) {
        return this.storage(this.options.defaults.storage);
      } else if (Object.keys(this.storageServices).length) {
        return this.storageServices[Object.keys(this.storageServices)[0]];
      } else {
        throw new Error('A storage scheme was required, but none was defined.');
      }
    }
  }, {
    key: "allStorage",
    value: function allStorage() {
      return Object.values(this.storageServices);
    }
    /** {@inheritDoc IFeatureServicesManager.addCacheService} */

  }, {
    key: "addCacheService",
    value: function addCacheService(service) {
      this.cacheServices[service.getStore()] = service;
    }
    /** {@inheritDoc IFeatureServicesManager.cache} */

  }, {
    key: "cache",
    value: function cache(store) {
      var _a;

      if (store) {
        if (!this.cacheServices[store]) {
          throw new Error("Cache store '".concat(store, "' required, but not defined."));
        } else {
          return this.cacheServices[store];
        }
      } else if ((_a = this.options.defaults) === null || _a === void 0 ? void 0 : _a.cache) {
        return this.cache(this.options.defaults.cache);
      } else if (Object.keys(this.cacheServices).length) {
        return this.cacheServices[Object.keys(this.cacheServices)[0]];
      } else {
        throw new Error('A cache store was required, but none was defined.');
      }
    }
  }, {
    key: "allCache",
    value: function allCache() {
      return Object.values(this.cacheServices);
    }
    /** {@inheritDoc IFeatureServicesManager.addQueueService} */

  }, {
    key: "addQueueService",
    value: function addQueueService(service) {
      this.queueServices[service.getStore()] = service;
    }
    /** {@inheritDoc IFeatureServicesManager.queue} */

  }, {
    key: "queue",
    value: function queue(store, identifier) {
      var service = this.queueServices[store];

      if (service) {
        var queue = service.getQueue(identifier);

        if (queue) {
          return new QueueService_1.BoundQueue(service, queue);
        } else {
          throw new Error("Queue '".concat(identifier, "' could not be found on store '").concat(store, "'."));
        }
      } else {
        throw new Error("Queue store '".concat(store, "' does not exist."));
      }
    }
  }, {
    key: "allQueue",
    value: function allQueue() {
      return Object.values(this.queueServices);
    }
    /** {@inheritDoc IFeatureServicesManager.setErrorService} */

  }, {
    key: "setErrorService",
    value: function setErrorService(service) {
      this.errorService = service;
    }
    /** {@inheritDoc IFeatureServicesManager.error} */

  }, {
    key: "email",
    get: function get() {
      if (!this.emailService) {
        throw new Error('Email Service is required, but not defined.');
      }

      return this.emailService;
    }
  }, {
    key: "error",
    get: function get() {
      return this.errorService || this.stubErrorService;
    }
  }]);

  return FeatureServicesManager;
}();

exports.FeatureServicesManager = FeatureServicesManager;